

/**
 * The base breakpoints for the Material Kit 2 PRO React.
 * You can add new breakpoints using this file.
 * You can customized the breakpoints for the entire Material Kit 2 PRO React using thie file.
 */

export default {
  values: {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400,
  },
};
